import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { WhyItHappensSection } from '../components/WhyItHappensSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatIncludedSection } from '../components/WhatIncludedSection';
import { ResultsTimeline } from '../components/ResultsTimeline';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  useMetaPixel();
  return <main className="min-h-screen w-full bg-white" data-id="element-282">
      <HeroSection data-id="element-283" />
      <PainSection data-id="element-284" />
      <WhyItHappensSection data-id="element-285" />
      <SolutionSection data-id="element-286" />
      <WhatIncludedSection data-id="element-287" />
      <ResultsTimeline data-id="element-288" />
      <ObjectionsSection data-id="element-289" />
      <FinalCTASection data-id="element-290" />
      <Footer data-id="element-291" />
    </main>;
}